module.exports = __webpack_public_path__ + "img/hard-drive.6754373c.svg";